import React from 'react';

// third-party
import { FormattedMessage } from 'react-intl';

// assets
import {
    BorderOutlined,
    BoxPlotOutlined,
    ChromeOutlined,
    DeploymentUnitOutlined,
    GatewayOutlined,
    MenuUnfoldOutlined,
    QuestionOutlined,
    SmileOutlined,
    StopOutlined,
    DashboardOutlined,
    VideoCameraOutlined,
    ScissorOutlined,
    SettingOutlined,
    SafetyCertificateOutlined,
    ControlOutlined,
    TabletOutlined,
    IssuesCloseOutlined,
    ApartmentOutlined,
    TeamOutlined
} from '@ant-design/icons';

// icons
const icons = {
    ChromeOutlined,
    TeamOutlined,
    DashboardOutlined,
    MenuUnfoldOutlined,
    BoxPlotOutlined,
    StopOutlined,
    BorderOutlined,
    SmileOutlined,
    GatewayOutlined,
    QuestionOutlined,
    DeploymentUnitOutlined,
    VideoCameraOutlined,
    ScissorOutlined,
    SettingOutlined,
    SafetyCertificateOutlined,
    ControlOutlined,
    TabletOutlined,
    ApartmentOutlined,
    IssuesCloseOutlined
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
    id: 'org_dashboard',
    title: <FormattedMessage id="dashboard" />,
    type: 'group',
    children: [
        {
            id: 'dashboard',
            title: <FormattedMessage id="dashboard" />,
            type: 'item',
            url: '/dashboard',
            icon: icons.DashboardOutlined
        },
        {
            id: 'analysis',
            title: <FormattedMessage id="accessControl" />,
            type: 'item',
            url: '/access-control',
            icon: icons.ControlOutlined
        },
        {
            id: 'accessControl',
            title: <FormattedMessage id="administration" />,
            type: 'item',
            url: '/administration',
            icon: icons.ApartmentOutlined
        },
        {
            id: 'myOrganization',
            title: <FormattedMessage id="myOrganization" />,
            type: 'item',
            url: '/my-organization',
            icon: icons.TeamOutlined
        }
        // {
        //     id: 'accessLogs',
        //     title: <FormattedMessage id="accessLog" />,
        //     type: 'item',
        //     url: '/access-logs',
        //     icon: icons.TeamOutlined
        // }
    ]
};

export default dashboard;
